import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useDocumentSources(fromDate: string, toDate: string) {
  return useQuery({
    queryKey: ["platformAnalytics", "documentSources", fromDate, toDate],
    queryFn: () =>
      api.getDocumentSources({ from_date: fromDate, to_date: toDate }),
  });
}
